import { render, staticRenderFns } from "./ModalTutorial.vue?vue&type=template&id=4126e67b&scoped=true&"
import script from "./ModalTutorial.vue?vue&type=script&lang=js&"
export * from "./ModalTutorial.vue?vue&type=script&lang=js&"
import style0 from "./ModalTutorial.vue?vue&type=style&index=0&id=4126e67b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4126e67b",
  null
  
)

export default component.exports